module.exports = __webpack_public_path__ + "img/1.141100ec.jpg";